import React, { PureComponent } from "react";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Tooltip from "@material-ui/core/Tooltip";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  item: {
    borderBottom: "1px dotted #667",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
    height: "2.5rem"
  },
  icon: {
    marginLeft: "16px",
    marginRight: 0
  },
  chevron: {},
  typography: {},
  text: {
    padding: "0 8px"
  }
});

class MenuItem extends PureComponent {
  handleClick = e => {
    e.preventDefault();
    if (this.props.force) window.location = this.props.url;
    else this.props.history.push(this.props.url);
  };

  render() {
    const {
      onClick,
      classes,
      color,
      icon: Icon,
      primary,
      secondary,
      tooltip,
      url,
      children
    } = this.props;
    const rslt = (
      <ListItem
        onClick={onClick || this.handleClick}
        button
        className={classes.item}
        color={color || "inherit"}
        href={url}
        component="a"
      >
        {Icon && (
          <ListItemIcon className={classes.icon}>
            <Icon />
          </ListItemIcon>
        )}
        <ListItemText
          color={color || "inherit"}
          disableTypography={false}
          className={classes.text}
          primary={primary}
          secondary={secondary}
        >
          {children}
        </ListItemText>
        <ListItemIcon className={classes.chevron}>
          <ChevronRightIcon />
        </ListItemIcon>
      </ListItem>
    );

    if (tooltip) {
      return <Tooltip {...tooltip}>{rslt}</Tooltip>;
    }

    return rslt;
  }
}

export default withStyles(styles, { name: "LcMenuItem" })(withRouter(MenuItem));
